import React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
import { change, getFormValues } from 'redux-form'
import { useSelector, useDispatch } from 'react-redux'
// context
import { PlanDetailsContext } from 'containers/Plan/Details/layers/API'
// constants
import { Modals, Forms } from 'constants/index'
// graphql
import { PLAN_TYPES_DETAILS_QUERY } from 'graphql/planType/queries'
// hooks
import { useModalData } from 'hooks/index'
// view components
import { Header } from 'components/Modals/ConfirmDeleteModal'
import { Button, Modal, BUTTON_LAYOUTS } from 'components/UI'
// themes
import { ActionsWrapper, Content, ContentText } from 'themes/views/modals'
// utils
import get from 'lodash/get'

const ConfirmChangePlanTypeModal: React.FC = () => {
  const dispatch = useDispatch()

  const [isLoading, setLoading] = React.useState<boolean>(false)

  const { initialValues, handleSubmit } = React.useContext(PlanDetailsContext)

  const {
    hideModal,
    modalData: { isOpen, planTypeId, width }
  } = useModalData({ modalType: Modals.CONFIRM_CHANGE_PLAN_TYPE_MODAL })

  const { data } = useQuery(PLAN_TYPES_DETAILS_QUERY, {
    fetchPolicy: 'network-only',
    skip: !planTypeId,
    variables: {
      filter: {
        ids: [planTypeId]
      }
    }
  })

  const { formValues } = useSelector((state) => ({
    formValues: getFormValues(Forms.PLAN_EDIT_FORM)(state)
  }))

  const fields = get(data, 'planTypes.data[0].fields')

  const handleCancelClick = () => {
    dispatch(change(Forms.PLAN_EDIT_FORM, 'planType', initialValues.planType))
    hideModal()
  }

  const handleConfirmClick = async () => {
    try {
      setLoading(true)

      await handleSubmit(formValues, fields)

      hideModal()
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal hideModal={hideModal} isOpen={isOpen} onClose={handleCancelClick} width={width}>
      <Header>Change Plan Type</Header>
      <Content>
        <ContentText color={'inherit'} style={{ fontWeight: 500 }}>
          Changing Plan Type may lead to loss of data as properties for the selected plan type may differ to those of
          the current plan type. Are you sure you would like to proceed with this change?
        </ContentText>
      </Content>
      <ActionsWrapper>
        <Button shadowLess isLoading={isLoading} layout={BUTTON_LAYOUTS.RED} onClick={handleConfirmClick}>
          Confirm
        </Button>
        <Button shadowLess layout={BUTTON_LAYOUTS.RED_INVERTED} onClick={handleCancelClick}>
          Cancel
        </Button>
      </ActionsWrapper>
    </Modal>
  )
}

export default ConfirmChangePlanTypeModal
